module.exports = __webpack_public_path__ + "img/rule-01.d070cb76.png";